import { AppCenterAPI } from 'api';
import { UseMutationOptions, useMutation } from 'react-query';
import { AxiosResponse } from 'axios';
import { ImpersonationParams } from './app-center.types';

export const useImpersonateUser = (
  config?: UseMutationOptions<AxiosResponse<any>, unknown, ImpersonationParams, unknown>
) => {
  return useMutation<AxiosResponse<any>, unknown, ImpersonationParams, unknown>(
    AppCenterAPI.impersonateUser,
    { ...config }
  );
};
export const usePatchImpersonation = (
  config?: UseMutationOptions<AxiosResponse<any>, unknown, ImpersonationParams, unknown>
) => {
  return useMutation<AxiosResponse<any>, unknown, ImpersonationParams, unknown>(
    AppCenterAPI.patchImpersonation,
    { ...config }
  );
};

export const useDeleteImpersonation = (
  config?: UseMutationOptions<AxiosResponse<any>, unknown, string, unknown>
) => {
  return useMutation<AxiosResponse<any>, unknown, string, unknown>(
    AppCenterAPI.deleteImpersonation,
    { ...config }
  );
};
